import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

const EditLeadType = ({ show, onClose, leadtypeIdToEdit, refresh }) => {
    const [leadtype_name, setname] = useState('');
    const [description, setDescription] = useState('');
    const [error, setError] = useState('');
    const [existingLeadtype, setExistingLeadtype] = useState([]);
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const formatleadtypeName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    useEffect(() => {
            if (show && leadtypeIdToEdit) {
                axios.get(`${baseURL}/leadtype/${leadtypeIdToEdit}`)
                    .then(response => {
                        // console.log("Fetched leadtype:", response.data);
                        // console.log("Fetched leadtype:", response.data);
                        const leadtype = response.data.data;
                        setname(leadtype.leadtype_name);
                        setDescription(leadtype.description || '');
                    })
                    .catch(error => {
                        console.error("Error fetching leadtype", error);
                    });

                    axios.get(`${baseURL}/leadtype`)
                    .then(response => {
                        setExistingLeadtype(
                            response.data.data.data
                                .filter(c => c.sno !== leadtypeIdToEdit) // exclude current one
                                .map(leadtype => leadtype.leadtype_name.toLowerCase())
                        );
                    })
                    .catch(error => {
                        console.error("Error fetching countries", error);
                    });
            }
        }, [show, leadtypeIdToEdit]);

        const validateInput = () => {
            // Check if the Lead type name is empty
            if (!leadtype_name.trim()) {
                setError("Leadtype is required.");
                return false;
            }
            
            const regex = /^[A-Za-z\s]+$/;
            if (!regex.test(leadtype_name)) {
                setError("Only text is valid.");
                return false;
            }
            
            const formattedLeadtypeName = leadtype_name.trim().toLowerCase();
            // Check if the leadtype already exists
            if (existingLeadtype.includes(leadtype_name.trim().toLowerCase())) {
                setError("Leadtype already exists.");
                return false;
            }
    
            setError('');
            return true;
        };


        const handleUpdate = (e) => {
            e.preventDefault();
    
            const formattedleadtypeName = formatleadtypeName(leadtype_name);
    
            if (!validateInput()) return;
    
            axios.put(`${baseURL}/leadtype/${leadtypeIdToEdit}`, {
                leadtype_name,
                description
            })
                .then(response => {
                    refresh();
                    onClose();
                    // window.location.reload(); // optional, can use state update instead
                    toast.success("Lead type Updated successfully!");
                })
                .catch(error => {
                    console.error("Error updating Lead type", error);
                    setError("An error occurred while updating the Lead type.");
                });
        };

    return (
        <Modal show={show}  size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Lead Type</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                <form onSubmit={handleUpdate}>
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Lead Type<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Lead Type" value={leadtype_name}
                            onChange={(e) => setname(formatleadtypeName(e.target.value))}/>
                            {error && <small className="text-danger">{error}</small>}
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea rows={2} className="form-control h-auto" name="comment" placeholder="Description" value={description}
                            onChange={(e) => setDescription(e.target.value)} />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        {/* <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link> */}
                        <button type="submit" className="btn btn-sm btn-primary">Update Lead Type<i className="fas fa-angle-double-right ms-2"></i></button>
                    </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default EditLeadType;
